__turbopack_context__.v({
  "identImageTitle": "VRsIJq_identImageTitle",
  "left": "VRsIJq_left",
  "right": "VRsIJq_right",
  "titleIdentImage": "VRsIJq_titleIdentImage",
});
